import api from './api';

const autoApprovalSettingsService = {
  // Get auto-approval settings
  getSettings: async () => {
    const response = await api.get('/admin/products/auto-approval-settings/');
    return response.data;
  },

  // Update auto-approval settings
  updateSettings: async (settingsData) => {
    const response = await api.put('/admin/products/auto-approval-settings/1/', settingsData);
    return response.data;
  },
};

export default autoApprovalSettingsService;

